/**
 * Shared metadata for the coach-character pages, used by both the canonical
 * `/characters/:name` route and the legacy `/meet/:name` alias.
 */
import { breadcrumbJsonLd } from "@/config/seoConfig";
import type { PageSeo } from "./head";

export function characterDisplayName(rawName: string): string {
  const raw = decodeURIComponent(rawName || "");
  return raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : "Character";
}

/** SEO descriptor for a single character page. `canonical` is site-relative. */
export function characterHeadSeo(rawName: string, canonical: string): PageSeo {
  const display = characterDisplayName(rawName);
  return {
    title: `Meet ${display} — LeadXkids Coach Character`,
    description: `Meet ${display}, one of the LeadXkids coach characters who guides children aged 8-14 through confidence, communication and life-skills stories.`,
    canonical,
    jsonLd: breadcrumbJsonLd([
        { name: "Home", url: "/" },
        { name: "Characters", url: "/characters" },
        { name: display, url: canonical },
      ]),
  };
}

/** SEO descriptor for the characters index (shared with the /meet alias). */
export function charactersIndexSeo(canonical: string): PageSeo {
  return {
    title: "Meet the Coach Characters for Kids 8-14",
    description:
      "Meet the LeadXkids coach characters — story guides who help children aged 8-14 practise confidence, communication and everyday life skills.",
    canonical,
    jsonLd: breadcrumbJsonLd([
      { name: "Home", url: "/" },
      { name: "Characters", url: "/characters" },
    ]),
  };
}
